function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLogicGAppCheckbox = function SvgIcLogicGAppCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    x: 0,
    y: 0,
    viewBox: "0 0 30 30"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 22.6c-.4 0-.8-.2-1.1-.5l-5.5-5.5c-.3-.3-.5-.7-.5-1.1s.2-.8.5-1.1c.6-.6 1.6-.6 2.3 0l4.4 4.4L22.5 8.2c.6-.6 1.6-.6 2.3 0 .6.6.6 1.6 0 2.2L13 22.2c-.3.3-.7.4-1.1.4",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z",
    style: {
      fill: "none"
    }
  }));
};
export default SvgIcLogicGAppCheckbox;